import React, { useEffect } from 'react';
import './i18n';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ProjectsSection from './components/ProjectsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import LegalPage from './components/LegalPage';
import AdminPage from './components/AdminPage';
import Scene3D from './components/Scene3D';
import { useTranslation } from 'react-i18next';

// SEO Component for dynamic meta tags
function SEOHead() {
  const location = useLocation();
  const { i18n } = useTranslation();
  
  useEffect(() => {
    const baseUrl = window.location.origin;
    const currentPath = location.pathname;
    
    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.href = `${baseUrl}${currentPath}`;
    }
    
    // Update Open Graph URL
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.content = `${baseUrl}${currentPath}`;
    }
    
    // Update page title based on route
    const titles = {
      '/': i18n.language === 'fr' 
        ? 'Med Stud Tech | Innovation Technologique - Médical, Finance, IA'
        : 'Med Stud Tech | Technological Innovation - Medical, Finance, AI',
      '/mentions-legales': i18n.language === 'fr'
        ? 'Mentions Légales | Med Stud Tech'
        : 'Legal Notice | Med Stud Tech',
      '/legal': 'Legal Notice | Med Stud Tech',
      '/admin': 'Administration | Med Stud Tech'
    };
    
    document.title = titles[currentPath] || titles['/'];
    
  }, [location, i18n.language]);
  
  return null;
}

function HomePage() {
  return (
    <>
      <Scene3D />
      <div className="relative z-10">
        <Navbar />
        <main>
          <HeroSection />
          <AboutSection />
          <ServicesSection />
          <ProjectsSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  );
}

function App() {
  useEffect(() => {
    document.documentElement.classList.remove('dark');

    // Check URL params for language
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    if (langParam === 'en' || langParam === 'fr') {
      // Language will be set by i18n
    }
  }, []);

  return (
    <div className="App min-h-screen bg-white text-zinc-950 overflow-x-hidden" data-testid="app-root">
      <BrowserRouter>
        <SEOHead />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mentions-legales" element={<LegalPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/admin" element={<AdminPage />} />
          {/* Catch-all redirect to home */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
